var render = function render(_c,_vm){return _c('v-alert',{attrs:{"dismissible":_vm.props.dismissible,"transition":"scale-transition","type":_vm.props.type,"outline":_vm.props.outline,"value":_vm.props.message},on:{"click":function($event){return _vm.$emit('dismissed')}}},[_vm._v(_vm._s(_vm.props.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }